
























import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { HsabAccountNametag } from "@/shared/types";
import { formatCurrency } from "@/shared/currency.js";
import { formatMMMDateString } from "@/shared/dateString";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";

@Component({
  components: {
    SsoDeepLink
  }
})
export default class NotionalAccountCardBody extends Vue {
  formatCurrency = formatCurrency;
  formatMMMDateString = formatMMMDateString;

  @Prop({ required: true })
  account: HsabAccountNametag;
}
